import ChallengePage from './ChallengePage';

export default ChallengePage;
